import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SealsBannerComponent } from './seals-banner.component';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [
        SealsBannerComponent
    ],
    declarations: [
        SealsBannerComponent
    ],
    providers: [],
})
export class SealsBannerModule { }
